import React from 'react';
import {Col} from 'react-bootstrap';
import {TextStyle} from '../assets/css/Styles';
import '../assets/css/Animations.css';

/**
 * @param {String} title - title for each page column
 * @return {Component} main title component
 */
export default function MainTitle({title}) {
  return (
    <Col style={TextStyle.mainTitleDiv}>
      <span id='main-title' style={TextStyle.mainTitleTxt}>
        {title}
      </span>
      <span style={TextStyle.mainTitleTxtBorderBottom} />
    </Col>
  );
}
